var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"c-auth-callback"}},[_c('h1',[_vm._v("OpenID Connect")]),(_vm.authorizeErrors)?_c('div',{staticClass:"error-alert"},[_vm._v(" "+_vm._s(_vm.authorizeErrors)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }